<template>
  <div class="summary-mnp">
    <h2 class="h3"><slot name="headline"></slot></h2>
    <ul class="list-unstyled">
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblProvider"></slot>
          </div>
          <div>{{ provider.brandName }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblMSISDN"></slot>
          </div>
          <div>{{ portingData.msisdn }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblContractEnd"></slot>
          </div>
          <div v-if="portingData.dateType === 'AS_SOON_AS_POSSIBLE'">
            <slot name="lblContractEndImmediatly"></slot>
          </div>
          <div v-else-if="portingData.dateType === 'CONTRACT_END'">
            <slot name="lblContractEndRegular"></slot>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'SummaryMNP',
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  computed: {
    portingData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/portingData'] || null
    },
    provider () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/provider'] || null
    }
  }
}
</script>
